import { equals, reject } from 'ramda';

const getValue = (value, tag) => reject((item) => equals(item, tag), value);

export default getValue;
